export enum LayoutType {
  PUBLISHER = 'publisher',
  PROJECT = 'project',
}
